<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="companyForm" :model="formData" :rules="rules" label-width="150px">
            <el-col :span="18" class="content-left">
              <el-form-item label="渠道名" prop="channel_name">
                <el-input v-model="formData.channel_name"></el-input>
              </el-form-item>
               <el-form-item label="渠道账号" prop="channel_account">
                <el-input v-model="formData.channel_account"></el-input>
              </el-form-item>
              <el-form-item label="收取税率子账号" prop="channel_rate_account">
                <el-input v-model="formData.channel_rate_account"></el-input>
              </el-form-item>
              <el-form-item label="天威证书文件" prop="certificate_file_name">
                <el-input v-model="formData.certificate_file_name"></el-input>
              </el-form-item>
              <!-- <el-form-item label="公钥文件" prop="publicKey_file_name">
                <el-input v-model="formData.publicKey_file_name"></el-input>
              </el-form-item> -->
              <el-form-item label="提现接口需要渠道号" prop="white_channel_code">
                <el-input v-model="formData.white_channel_code"></el-input>
              </el-form-item>
              <el-form-item label="约唯一ID" prop="partner_id">
                <el-input v-model="formData.partner_id"></el-input>
              </el-form-item>
              <el-form-item label="签名方式" prop="sign_type">
                <el-input v-model="formData.sign_type"></el-input>
              </el-form-item>
              <el-form-item label="apiURL" prop="api_url">
                <el-input type="textarea" v-model="formData.api_url"></el-input>
              </el-form-item>
              <!-- <el-form-item label="税费" prop="rate">
                <el-input v-model="formData.rate"></el-input>
              </el-form-item> -->
              <el-form-item label="法人" prop="legal_person">
                <el-input v-model="formData.legal_person"></el-input>
              </el-form-item>
              <el-form-item label="法人身份证" prop="legal_idcard">
                <el-input v-model="formData.legal_idcard"></el-input>
              </el-form-item>
              <el-form-item label="法人手机号" prop="legal_phone">
                <el-input v-model="formData.legal_phone"></el-input>
              </el-form-item>
              <el-form-item label="纳税人识别号" prop="taxpayer">
                <el-input v-model="formData.taxpayer"></el-input>
              </el-form-item> 
            </el-col>
            <el-col class="content-right" :span="6">
              <!-- <el-form-item label="附件" prop="attachment">
                <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="attachmentType" @handleUploadSuccess="handleAttachmentUploadSuccess" @handleUploadRemove="handleAttachmentUploadRemove" :upload-file-list="attachmentUploadFileList"></ApeUploader>
              </el-form-item> -->
              <el-form-item label="状态" prop="status" size="small">
                <el-radio-group v-model="formData.status">
                  <el-radio-button label="0">停用</el-radio-button>
                  <el-radio-button label="1">启用</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <div class="right-button">
                <el-button size="medium" type="primary"  :disabled="formDisabled" @click="saveConfirm">保存</el-button>
                <el-button size="medium" @click="returnList">返回</el-button>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeUploader from '@/components/ApeUploader'
import ApeEditor from '@/components/ApeEditor'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeUploader,
    ApeEditor,
  },
  data() {
    return {
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      companyId:0, // 账户id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      openapiList:[],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 账户基本信息表单结构
      formData:{
        status:0
      },
      // 已上传图片列表
      uploadFileList:[],
      // 账户基本信息规则
      rules: {
        name: [
          {required: true, message: '输入账户名称', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    // 返回列表
    returnList() {
      this.$router.push('/settlement')
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 账户相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      console.log("formData -> ", this.formData);
      let id = await this.$api.saveSettlement(this.formData)
      if (id) {
        this.$notify.success('保存成功！')
      }

      if (this.companyId === 0 && id) {
        // this.$router.push(this.$route.matched[1].path+'/'+id+'/edit')
        this.$router.push(this.$route.matched[1].path)
        // this.initcompanyForm()
      }
      this.$nextTick(() => {
        this.loadingStaus = false
      })
    },
    // 初始化账户基本信息
    async initForm() {
      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      console.log("action -> ", this.$route.params)
      if (this.$route.params.id) {
        this.id = this.$route.params.id
      }
      if (this.id) {
        let {info} = await this.$api.getSettlementInfo(this.id)
        console.log("formData", info)
        this.formData = info
      }
    },
  },
  async mounted() {
    this.loadingStaus = true
    this.initForm()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
      /deep/.el-button
        margin-right: 10px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
</style>
